export enum ServersActionTypes {
    INIT_SERVERS  = '@@servers/INIT_SERVERS',
    CREATE_SERVER = '@@servers/CREATE_SERVER',
    SELECT_SERVER = '@@servers/SELECT_SERVER',
    UPDATE_SERVER = '@@servers/UPDATE_SERVER',
    REMOVE_SERVER = '@@servers/REMOVE_SERVER',
}



// WEBPACK FOOTER //
// ./src/modules/servers/store/types.ts